module.exports = __webpack_public_path__ + "img/sys-name-en.5b57527e.png";